import { render } from "./ExpandableSection.vue?vue&type=template&id=6ea91263&scoped=true"
import script from "./ExpandableSection.vue?vue&type=script&lang=js"
export * from "./ExpandableSection.vue?vue&type=script&lang=js"

import "./ExpandableSection.vue?vue&type=style&index=0&id=6ea91263&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea91263"]])

export default __exports__